//@flow

import React from 'react';

const FACEBOOK_LINK = 'https://www.facebook.com/NatureBox/';
const TWITTER_LINK = 'https://twitter.com/naturebox';
const LINKEDIN_LINK = 'https://www.linkedin.com/company/naturebox';
const INSTAGRAM_LINK = 'https://www.instagram.com/naturebox';

type Props = {
  platform:string,
  url:string,
  text:string,
  shareLink?:boolean,
};

const makeLinkValues = (platform:string, url:string, text:string, shareLink?:boolean) => {
  const host = window.location.host;
  const protocol = window.location.protocol;
  const raw = `${protocol}//${host}${url}`;
  const nbUrl = encodeURIComponent(raw);
  const textEncoded = encodeURIComponent(text);

  let link = "";
  let iconClass = "";
  let aClass = "";

  if (platform === 'facebook') {
    link = shareLink
      ? `https://www.facebook.com/sharer/sharer.php?u=${nbUrl}`
      : FACEBOOK_LINK;
    iconClass = "social-facebook";
    aClass = "background-facebook";
  }
  else if (platform === "linkedIn") {
    link = shareLink
      ? `https://www.linkedin.com/shareArticle?mini=true&url=${nbUrl}&title=${textEncoded}&summary=${textEncoded}&source=LinkedIn`
      : LINKEDIN_LINK;
    iconClass = "social-linkedin";
    aClass = "background-linkedin";
  }
  else if (platform === "twitter") {
    link = shareLink
      ? `https://twitter.com/intent/tweet?url=${nbUrl}&text=${textEncoded}`
      : TWITTER_LINK;
    iconClass = "social-twitter";
    aClass = "background-twitter";
  }
  else if (platform === "instagram") {
    // TODO: figure out how to format shareable link for instagram
    link = INSTAGRAM_LINK;
    iconClass = "social-instagram";
    aClass = "background-instagram";
  }
  return {link, iconClass, aClass};
};


function SocialLink(props:Props) {
  const {link, iconClass, aClass} = makeLinkValues(props.platform, props.url, props.text, props.shareLink);

  return (
    <div className="social-link-container">
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        className={`social-link-a ${aClass}`}
      >
        <div className={`${iconClass} social-link-icon`} />
      </a>
    </div>
  );
}

SocialLink.defaultProps = {
  text: "",
  shareLink: true,
};

export default SocialLink;
